module.exports = {"contact":{"email":{"feedback":"feedback@yoop.app","sales":"sales@yoop.app","press":"info@yoop.app","support":"support@yoop.app"},"zendesk":{"base":"https://yoop.zendesk.com/hc/es","customPaths":{"virtualEvents":"/sections/360009057052-Eventos-virtuales"}},"social":{"instagram":"https://www.instagram.com/yoop/","twitter":"https://twitter.com/yoop","facebook":"https://www.facebook.com/yoopevents"}}}


//////////////////
// WEBPACK FOOTER
// /codebuild/output/src891534606/src/modules/web/src/js/i18n/spanish/contact.es.i18n.json
// module id = 1333
// module chunks = 0